/*
 * @Author: tyz tyz.bnu@gmail.com
 * @Date: 2025-03-13 14:08:41
 * @LastEditors: tyz tyz.bnu@gmail.com
 * @LastEditTime: 2025-03-26 22:03:07
 * @FilePath: \vue-cesium-start\src\common\js\initCesium.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { CesiumIonDefaultAccessToken, TianDiTuToken } from './config'

export function initCesium(Cesium) {
  // 使用Cesium官方示例中的Token
  Cesium.Ion.defaultAccessToken = CesiumIonDefaultAccessToken || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI2YmRiNjM4MC1kMDZkLTQ2NDQtYjQ3My0xZDI4MDU0MGJhZDciLCJpZCI6MzIxMzAsInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1OTY1MjM4NzZ9.A3FBZ6HjKkTsOGnjwWWeO9L10HQ9c-wcF4c3dtTc4gQ'

  // 创建Viewer
  const viewer = new Cesium.Viewer('cesiumContainer', {
    shouldAnimate: true,
    animation: false, // 是否创建动画小器件，左下角仪表
    baseLayerPicker: false, // 是否显示图层选择器
    fullscreenButton: false, // 是否显示全屏按钮
    geocoder: false, // 是否显示geocoder小器件，右上角查询按钮
    homeButton: false, // 是否显示Home按钮
    infoBox: false, // 是否显示信息框
    sceneModePicker: false, // 是否显示3D/2D选择器
    selectionIndicator: false, // 是否显示选取指示器组件
    timeline: false, // 是否显示时间轴
    navigationHelpButton: false, // 是否显示右上角的帮助按钮
    scene3DOnly: false, // 如果设置为true，则所有几何图形以3D模式绘制以节约GPU资源
    imageryProvider: new Cesium.WebMapTileServiceImageryProvider({
      url: 'https://swapi2.siweiearth.com/sj_raster/v6/wmts/tile/10002601/0?ak=sf2c6d19f971bccfa0612ba3e496bb7fd1&service=WMTS&request=GetTile&version=1.0.0&layer=&style=&tilematrixSet=GoogleMapsCompatible&transparent=1&width=256&height=256&opacity=1&srs=EPSG:3857&tilematrix={TileMatrix}&tilerow={TileRow}&tilecol={TileCol}',
      layer: 'tdtBasicLayer',
      style: 'default',
      format: 'image/jpeg',
      tileMatrixSetID: 'GoogleMapsCompatible',
    })
  })

  // 创建注记路网图层（高德地图路网）
  const roadNetworkProvider = new Cesium.UrlTemplateImageryProvider({
    url: 'http://webst02.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scale=1&style=8',
    minimumLevel: 3,
    maximumLevel: 18,
    credit: '高德地图'
  })

  // 存储路网图层实例
  let roadNetworkLayer = null

  // 添加切换路网的函数
  viewer.toggleRoadNetwork = function (show) {
    if (show) {
      if (!roadNetworkLayer) {
        roadNetworkLayer = viewer.imageryLayers.addImageryProvider(roadNetworkProvider)
      }
    } else {
      if (roadNetworkLayer) {
        viewer.imageryLayers.remove(roadNetworkLayer)
        roadNetworkLayer = null
      }
    }
  }

  return viewer
}